<!-- Chrome-less for: solar embed (/company/... iframed on partner sites), the public customer feedback
     page (/feedback?token=...) and external clients (flag login) — hiding the header/breadcrumbs reclaims space,
     especially on mobile. -->
@if (!isChromeless) {
  <app-header />
}
<p-toast #toast [preventOpenDuplicates]="true" />
<app-confirmation />
@if (!isChromeless) {
  <app-breadcrumbs />
}
<router-outlet />

@if (loadingService.isLoading && !currentUserService.currentUser && !url.includes('customer-login') && !url.startsWith('/feedback')) {
  <div class="card flex justify-center">
    <p-progress-spinner ariaLabel="loading" />
  </div>
}
